import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import AuthGate from "./components/AuthGate";
import NmsAuthGate from "./components/NmsAuthGate";
import TopBar from "./components/TopBar";
import HomePage from "./routes/HomePage";
import FleetPage from "./routes/FleetPage";
import CodePage from "./routes/CodePage";

export default function App() {
  return (
    <AuthGate>
      <NmsAuthGate>
        <AuthedApp />
      </NmsAuthGate>
    </AuthGate>
  );
}


function AuthedApp() {
  const location = useLocation();
  // /fleet/<variantId>  → full-bleed fleet view (no <main> wrapper padding)
  // /code/<code>        → resolves to /fleet/<variantId>?tail=<tail>, so
  //                        treat it as fleet-shaped for layout purposes.
  const onFleet =
    location.pathname.startsWith("/fleet/") ||
    location.pathname.startsWith("/code/");

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <TopBar />
      {onFleet ? (
        <Routes>
          <Route path="/fleet/:variantId" element={<FleetPage />} />
          <Route path="/code/:code"       element={<CodePage />} />
        </Routes>
      ) : (
        <main className="mx-auto max-w-7xl p-6">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      )}
    </div>
  );
}
